/* ---------------------------------------------------------------------
   1️⃣  React – TiendaNubeConnectForm.jsx
   ------------------------------------------------------------------ */
   import React, { useState } from "react";
   import axios from "axios";
   
   const TiendaNubeConnectForm = () => {
     const [storeId, setStoreId] = useState("");
     const [accessToken, setAccessToken] = useState("");
     const [saving, setSaving] = useState(false);
     const [okMsg, setOkMsg] = useState("");
     const [errMsg, setErrMsg] = useState("");
   
     const handleSubmit = async (e) => {
       e.preventDefault();
       setOkMsg("");
       setErrMsg("");
   
       if (!storeId.trim() || !accessToken.trim()) {
         setErrMsg("Completa ambos campos.");
         return;
       }
   
       try {
         setSaving(true);
         await axios.post("/api/tiendanube/connect", {
           storeId: storeId.trim(),
           accessToken: accessToken.trim(),
         });
         setOkMsg("¡Guardado! Ya puedes listar tus productos.");
       } catch (err) {
         console.error(err);
         setErrMsg(err.response?.data?.error || "Error inesperado");
       } finally {
         setSaving(false);
       }
     };
   
     return (
       <form
         onSubmit={handleSubmit}
         className="flex flex-col gap-4 p-4 w-full max-w-md mx-auto bg-white rounded-2xl shadow-lg"
       >
         <h2 className="text-xl font-semibold text-center">Conectar Tiendanube</h2>
   
         <label className="text-sm font-medium">
           Store ID
           <input
             type="text"
             value={storeId}
             onChange={(e) => setStoreId(e.target.value)}
             className="mt-1 block w-full rounded-md border py-2 px-3"
             placeholder="1234567"
           />
         </label>
   
         <label className="text-sm font-medium">
           Access Token
           <input
             type="text"
             value={accessToken}
             onChange={(e) => setAccessToken(e.target.value)}
             className="mt-1 block w-full rounded-md border py-2 px-3"
             placeholder="shp_********"/>
         </label>
   
         <button
           type="submit"
           className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-xl disabled:opacity-50"
           disabled={saving}
         >
           {saving ? "Guardando…" : "Guardar"}
         </button>
   
         {okMsg && <p className="text-green-600 text-center text-sm">{okMsg}</p>}
         {errMsg && <p className="text-red-600 text-center text-sm">{errMsg}</p>}
       </form>
     );
   };
   
   export default TiendaNubeConnectForm;
   